import { InjectionToken } from '@angular/core';

export const churnFormTranslations = {
  form: {
    questions: {
      likelyToReturn: 'app.churn_form.step_2.form.likely_to_return',
      otherSolution: 'app.churn_form.step_2.form.other_solution',
      reason: 'app.churn_form.step_2.form.reason',
      reasonToStay: 'app.churn_form.step_2.form.reason_to_stay',
      whatYouLiked: 'app.churn_form.step_2.form.what_you_liked',
    },
    errors: {
      minLength: 'app.churn_form.step_2.form.answer_minlength',
      answerRequired: 'app.common.form.required_error',
    },
    textareaPlaceholder: 'app.interview.question.placeholder',
    otherReasonPlaceholder: 'app.churn_form.step_2.form.reason_input_placeholder',
    otherSolutionPlaceholder: 'app.churn_form.step_2.form.other_solution_input_placeholder',
    likelyToReturnScale: {
      absolutelyWill: 'app.churn_form.step_2.form.absolutely_will',
      noChance: 'app.churn_form.step_2.form.no_chance',
    },
  },
  proceedWithCancellation: 'app.churn_form.step_2.form.proceed_with_cancellation',
  stayWithUs: 'app.churn_form.step_2.form.stay_with_recruitee',
};

export type ChurnFormTranslations = typeof churnFormTranslations;

export const ChurnFormTranslationsToken = new InjectionToken<ChurnFormTranslations>(
  'ChurnFormTranslationsToken',
);
